import GroupingPage from '~/Layouts/Themes/GroupingPage/GroupingPage';
import SingleBundlePage from '~/Layouts/Themes/SingleBundlePage/SingleBundlePage';
import { CategoryThemes } from '~/types/category';
import BundleSelector from './BundleSelector/BundleSelector';

interface IThemeManager {
    category: ICategory;
    bundles: number[];
}

export const isThemeEnabled = (themeName: CategoryThemes) => {
    return [CategoryThemes.GROUPING_PAGE_THEME, CategoryThemes.SINGLE_BUNDLE_PAGE, CategoryThemes.BUNLDE_SELECTOR].includes(themeName);
};

const ThemeManager = ({ bundles, category }: IThemeManager) => {
    switch (category.theme) {
        case CategoryThemes.GROUPING_PAGE_THEME:
            return <GroupingPage bundles={bundles} />;

        case CategoryThemes.SINGLE_BUNDLE_PAGE:
            return <SingleBundlePage bundleId={bundles?.[0]} />;

        case CategoryThemes.BUNLDE_SELECTOR:
            return <BundleSelector bundlesIds={bundles} category={category} />;
    }

    return null;
};

export default ThemeManager;
